import type { CSSProperties } from "react";

/** Shared label sizing for every horizontal analysis chart; long names wrap. */
export function analysisChartLabelStyle(labels: readonly string[]): CSSProperties & { "--pa-label-width": string; "--pa-label-gap": string } {
  return {
    "--pa-label-width": `${Math.min(240, Math.max(100, ...labels.map(label => label.length * 8 + 24)))}px`,
    "--pa-label-gap": "16px",
  };
}
